
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { formatData } from "../../../constants/config.js";
export default {
    components: {
        vcLoading   : () => import('../../../components/pages/loading.vue'),
        breadcrumbs : () => import('../../../components/pages/breadcrumbs.vue'),
        basicTable  : () => import('../../../components/pages/basic-table.vue')
    },
    data() {
        return {
            isLoading           : true
        };
    },
    computed: {
        ...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang',
            getterSatement  : "getterSatement",
        }),
        getTableFields(){

            return [
            { 
                key			: 'document_date', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.date[this.getterStoreLang], 
                class		: "text-left w-15 d-none d-sm-table-cell", 
                formatter	: (value, key, item) => { 
                    
                    return moment(value.toString().split(".")[0]).format('lll');
                } 
            },
            { 
                key			: 'order_number', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.order_number[this.getterStoreLang], 
                class		: "text-center w-15", 
                formatter	: (value, key, item) => { 
                    if( item.document === 'Invoice' ){
                        
                        return item.invoice?.order ? item.invoice.order.name : "";
                    }
                    else if( item.document === "Payment" ){
                        
                        return item.payment.note;
                    }
                    else if( item.document === "CreditNote" ){
                        
                        return item.creditNote.order ? item.creditNote.order.name : item.creditNote.reference;
                    }
                    else{
                        
                        return "";
                    }
                } 
            },
            { 
                key			: 'document', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.type_document[this.getterStoreLang], 
                class		: "text-center w-15 d-md-table-cell d-none" 
            },
            { 
                key			: 'reference', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.reference_document[this.getterStoreLang], 
                class		: "text-center w-15", 
                formatter	: (value, key, item) => { 
                    if( item.document === 'Invoice' ){
                        
                        return item.invoice?.order ? item.invoice.order.name : "";
                    }
                    else if( item.document === "Payment" ){
                        
                        return item.payment.note;
                    }
                    else if( item.document === "CreditNote" ){
                        
                        return item.creditNote.order ? item.creditNote.order.name : item.creditNote.reference;
                    }
                    else{
                        
                        return "";
                    }
                } 
            },
            { 
                key			: 'amount', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.amount[this.getterStoreLang], 
                class		: "text-center w-15" 
            },
            { 
                key			: 'balance', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.current_balance[this.getterStoreLang], 
                class		: "text-center w-15 d-none d-sm-table-cell" 
            },
            { 
                key			: 'actions', 
                label		: this.getterTranslates.pages.account.dashboard.my_statement.table_transactions.actions[this.getterStoreLang], 
                class		: "text-center w-10 hide-title" 
            }
            ];
        }
    },
    async mounted(){
        
        await this.getStatementByCustomer().then( (result_statement) => {
            
            this.isLoading = null;
        });
    },
    methods:{
        ...mapActions({
            getStatementByCustomer: "getStatementByCustomer"
        }),
        formatCurrency(price){
            return formatData.currency(price);
        }
    }
}
